var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('SalesTable',{attrs:{"items":_vm.sales,"pagination":_vm.salesPagination,"type":"supplier","reference":_vm.supplier_id,"hover":"","striped":"","border":"","small":"","fixed":"","caption":"Historial de Ventas"},on:{"refresh":_vm.refreshItems}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }